import { orchestrator } from 'satcheljs';
import { deleteRequest } from '../services/deleteRequest';
import { getPremiumUser } from '../actions/getPremiumUser';
import { removeSecondaryUserEmail } from '../actions/removeSecondaryUserEmail';
import setIsRemovingEmailAddress from '../mutators/setIsRemovingEmailAddress';
import { traceSecondaryUserEmailRemoveButtonClick } from '../utils/domainOptionTracer';

const deleteAliasUrl: string = 'ows/api/beta/PremiumUser/secondaryuseralias?emailAddress={0}';

export default orchestrator(
    removeSecondaryUserEmail,
    async removeSecondaryUserEmailActionMessage => {
        const { email } = removeSecondaryUserEmailActionMessage;
        traceSecondaryUserEmailRemoveButtonClick();
        setIsRemovingEmailAddress(true);
        await deleteRequest(deleteAliasUrl, email);
        getPremiumUser();
        setIsRemovingEmailAddress(false);
    }
);
